import { Nullable } from '@types'

import { ShortlistSortOrder } from '@modules/shortlist/types'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

const getArrowColor = (direction: 'up' | 'down', sortOrder: Nullable<ShortlistSortOrder>) => {
  if (!sortOrder) {
    return '#9b9a9a'
  }

  const directionMap = {
    up: ShortlistSortOrder.ASC,
    down: ShortlistSortOrder.DESC,
  }

  if ([directionMap[direction], ShortlistSortOrder.NOT_ASC_DESC].includes(sortOrder)) {
    return '#ffffff'
  }

  return '#0a0a0a'
}

interface RootProps {
  $isActive: boolean
  $order: Nullable<ShortlistSortOrder>
}

export const Root = styled(Box)<RootProps>`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 18px;
  min-height: 18px;
  border-radius: 9px;
  transition: 0.2s;
  cursor: pointer;

  background-color: ${({ $isActive }: { $isActive?: boolean }) => ($isActive ? colors.primary : '#ededed')};

  &:hover {
    background-color: ${({ $isActive }: { $isActive?: boolean }) => ($isActive ? colors.primaryDark : colors.backgroundGrey)};
  }

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 10.5px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 3px 4px 3px;
    border-color: transparent;
    border-bottom-color: ${({ $order }: { $order: Nullable<ShortlistSortOrder> }) => getArrowColor('up', $order)};
  }

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 10.5px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 4px 3px 0 3px;
    border-color: transparent;
    border-top-color: ${({ $order }: { $order: Nullable<ShortlistSortOrder> }) => getArrowColor('down', $order)};
  }
`
